import { Component, OnInit, ViewChild } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { ActionsToRemoveComponent } from "./actions-to-remove/actions-to-remove.component";

@Component({
	selector: "app-unassign-group-actions",
	templateUrl: "./unassign-group-actions.component.html",
	styleUrls: ["./unassign-group-actions.component.css"],
})
export class UnassignGroupActionsComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.GroupName = this.SelectedGroup.GroupName;
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	SelectedGroup: any;
	GroupName: any = "";

	@ViewChild(ActionsToRemoveComponent)
	TableRef: ActionsToRemoveComponent;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onUnassign() {
		//Create list of actions
		var lstActionInts: number[] = [];
		var lstPointsGroupTransactionIDs: number[] = [];

		//Add selected actions
		for (var i = 0; i < this.TableRef.SelectedGroupActions.length; i++) {
			var next = this.TableRef.SelectedGroupActions[i];

			if (next.GroupActionTypeID != 4) {
				lstActionInts = [...lstActionInts, next.GroupActionID];
			} else if (next.GroupActionTypeID == 4) {
				lstPointsGroupTransactionIDs = [...lstPointsGroupTransactionIDs, next.PointsGroupTransactionID];
			}
		}

		var Info: any = {
			lstActionInts: lstActionInts,
			lstPointsGroupTransactionIDs: lstPointsGroupTransactionIDs,
		};

		this.ref.close(Info);
	}

	onCancel() {
		this.ref.close(-1);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	IsLoading() {
		if (this.TableRef == undefined) {
			return true;
		}

		return this.TableRef.loading == true;
	}

	/////////////////////////////////////////
}
